import { render, staticRenderFns } from "./Studenten.vue?vue&type=template&id=511c3561"
import script from "./Studenten.vue?vue&type=script&lang=js"
export * from "./Studenten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports